import { render, staticRenderFns } from "./Imei.vue?vue&type=template&id=98a61ca0&scoped=true"
import script from "./Imei.vue?vue&type=script&lang=js"
export * from "./Imei.vue?vue&type=script&lang=js"
import style0 from "./Imei.vue?vue&type=style&index=0&id=98a61ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a61ca0",
  null
  
)

export default component.exports